var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',_vm._g({staticClass:"google-map",attrs:{"src":_vm.mapSrc,"frameborder":"0","allowfullscreen":""}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }